import { useLocation } from "react-router-dom";

export type SiteLocale = "ro" | "en";

export const SITE_LOCALES: readonly SiteLocale[] = ["ro", "en"];

/** Default locale; LanguageRoute also sends unprefixed paths to /ro. */
export const DEFAULT_SITE_LOCALE: SiteLocale = "ro";

/**
 * Returns the locale encoded in the first path segment ("/en/faq" → "en"),
 * or null when the path carries no supported locale.
 */
export function localeFromPath(pathname: string): SiteLocale | null {
  const first = pathname.split("/")[1];
  return (SITE_LOCALES as readonly string[]).includes(first) ? (first as SiteLocale) : null;
}

/**
 * Locale of the current page, read from the URL.
 *
 * Locale routes are declared with literal prefixes ("/ro/*", "/en/*"), so
 * `useParams().locale` is always undefined there — reading it made every link
 * and redirect built from it point at /ro even on /en pages (JUB-100). Paths
 * without a locale prefix (e.g. /@slug) fall back to the default locale, as
 * the old `locale || "ro"` code did.
 */
export function useRouteLocale(): SiteLocale {
  const { pathname } = useLocation();
  return localeFromPath(pathname) ?? DEFAULT_SITE_LOCALE;
}
